import React from 'react';

const SvgPayment34 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M10.5 12h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm5.5 2H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h7zm0-10H3a1 1 0 0 1 0-2h13a2 2 0 0 0-2-2H3a3 3 0 0 0-3 3v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgPayment34 svgRef={ref} {...props} />);
export default ForwardRef;
